import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import {Sidebar} from "primereact/sidebar";
import {Button} from "primereact/button";
import Message from "./Helpers/Message.js";
import {Toolbar} from "primereact/toolbar";
import {Dialog} from "primereact/dialog";
import {Box} from "@mui/system";
import LinearProgress from "@mui/material/LinearProgress";
import MenuIcons from "./MenuIcons.js";
import Dashboard from "./Sections/Dashboard.js";
import Users from "./Sections/Users.js";
import UserSettings from "./Sections/UserSettings";
import ActivityLog from "./Sections/ActivityLog.js";
import Providers from "./Sections/Providers.js";
import Products from "./Sections/Products.js";
import Centers from "./Sections/Centers.js";
import ProductsMUs from "./Sections/ProductsMUs.js";
import CentersRequestsYearly from "./Sections/CentersRequestsYearly.js";
import CentersRequestTemplates from "./Sections/CentersRequestTemplates.js";
import ProductsTypes from "./Sections/ProductsTypes.js";
import FrameAgreements from "./Sections/FrameAgreements.js";
import SubAgreements from "./Sections/SubAgreements.js";
import ProductsSummaryYearly from "./Sections/ProductsSummaryYearly.js";
import Aquisitions from "./Sections/Aquisitions.js";
import DirectAquisitions from "./Sections/DirectAquisitions.js";
import UnitData from "./Sections/UnitData.js";
import MonthlyRequestsTemplates from "./Sections/MonthlyRequestsTemplates.js";
import MonthlyRequestsTypes from "./Sections/MonthlyRequestsTypes.js";
import MonthlyRequests from "./Sections/MonthlyRequests.js";
import CommandNotes from "./Sections/CommandNotes.js";
import RegistruIntrari from "./Sections/RegistruIntrari.js";
import EFacturi from "./Sections/EFacturi.js";

import {fetch_url_post} from "../Sources/js/app.js";
import { CommentsDisabledOutlined } from "@mui/icons-material";

let oper="";
let defaultDialogValues={
	openUserSettings: false,
	titleUserSettings: "Setari utilizator",
};

export default function MainPage(props) {

	const dataOk=(props.session.sessId?true:false);
	const [menuOpen, setMenuOpen] = useState(false);
	const [menuSections, setMenuSections] = useState([]);
	const [messageText, setMessageText] = useState(null);
	const [pendingAnafCode, setPendingAnafCode] = useState(null);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [menuCategories, setMenuCategories] = useState([]);
	const [menuCategory, setMenuCategory] = useState(window.localStorage.getItem("erpMenuCategoryXa7"));
    const location = useLocation();
    const navigate = useNavigate();

//	console.log("in LS we have "+window.localStorage.getItem("erpMenuCategoryXa7"));
//	console.log("Geting new menu category: "+menuCategory);

	const handleButton = (evt,what) => {
		if(what==="menu") {
			setMenuOpen(!menuOpen);
		}
		if(what==="user_settings") {
			setDialogValues({...dialogValues,openUserSettings: true});
		}
		if(what==="dashboard") {
			navigate("/");
		}
	}

	const success_handler = (result) => {
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if(oper==="getMenuSections") {
			setMenuSections(result.menuItems?result.menuItems:[]);
			setMenuCategories(result.menuCategories?result.menuCategories:[]);
		}
		if(oper==="validateSession") {
			if(result.is_auth===1) {
				props.loginHandler(result);
			}else{
				navigate("/login");
			}
		}
		oper="";
	}

	const fail_handler = () => {
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	useEffect(() => {
		window.localStorage.removeItem("erpReturnPathXa7");
		if(window.location.pathname !== '/anaf-callback') {
			window.localStorage.setItem("erpReturnPathXa7",(location.pathname?location.pathname:"/"));
		}
		if(!props.session.sessId) {
			if(!window.localStorage.getItem("erpSessIdXa7")) {
				navigate("/login");						
			}
			validateSession(window.localStorage.getItem("erpSessIdXa7"));
		}else{
			oper="getMenuSections";
			let url="getMenuSections";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}
	},[props.session.sessId]);

	const validateSession = (sessionId) => {
		oper="validateSession";
		let url="validateSession";
		url+="?session_id="+sessionId;
		let data={};
		fetch_url_post(url,data,success_handler,fail_handler);
	}

	// Detectare automata cod ANAF din URL la redirect callback
	useEffect(() => {
		if(window.location.pathname === '/anaf-callback') {
			const params = new URLSearchParams(window.location.search);
			const code = params.get('code');
			if(code) {
				setPendingAnafCode(code);
			}else{
				setMessageText("Eroare autorizare ANAF: " + (params.get('error') || 'access_denied'));
				navigate("/unitData");
			}
		}
	}, []);

	// Exchange cod ANAF dupa ce sesiunea e disponibila
	useEffect(() => {
		if(pendingAnafCode && props.session.sessId) {
			let url = "anafExchangeCode?session_id=" + props.session.sessId;
			fetch_url_post(url, {code: pendingAnafCode},
				(result) => {
					setPendingAnafCode(null);
					if(result.ok === 1) {
						// Hard redirect pentru refresh complet al starii ANAF
						window.location.href = window.location.origin + "/#/unitData?anaf=ok";
					}else{
						window.location.href = window.location.origin + "/#/unitData?anaf=error";
					}
				},
				() => {
					setPendingAnafCode(null);
					window.location.href = window.location.origin + "/#/unitData?anaf=error";
				}
			);
		}
	}, [pendingAnafCode, props.session.sessId]);

	const handleSection = (evt,section) => {
		//used only for menu sections and appbar sections
		setMenuOpen(false);
		//set menu section
		window.localStorage.setItem("erpMenuCategoryXa7",menuCategory);
//		console.log("Setting menu category to: "+window.localStorage.getItem("erpMenuCategoryXa7"));		
		switch(section) {
			case "Pagina principala":
				navigate("/");
				break;
			case "Utilizatori":
				navigate("/users");
				break;
			case "Jurnal activitati":
				navigate("/activityLog");
				break;
			case "Nomenclator furnizori":
				navigate("/providers");
				break;
			case "Nomenclator produse":
				navigate("/products");
				break;
			case "Nomenclator centre":
				navigate("/centers");
				break;
			case "Necesare ANUALE":
				navigate("/centersRequestsYearly");
				break;
			case "Nomenclator U.M.":
				navigate("/mus");
				break;
			case "Sabloane ANUALE":
				navigate("/CentersRequestTemplates");
				break;
			case "Nomenclator tipuri":
				navigate("/productsTypes");
				break;
			case "Contracte cadru":
				navigate("/frameAgreements");
				break;
			case "Contracte subsecvente":
				navigate("/subAgreements");
				break;
			case "Centralizator ANUAL":
				navigate("/productsSummaryYearly");
				break;
			case "Achizitii cu contract":
				navigate("/aquisitions");
				break;
			case "Achizitii directe":
				navigate("/directAquisitions");
				break;
			case "Date unitate":
				navigate("/unitData");
				break;
			case "Sabloane LUNARE":
				navigate("/monthlyRequestsTemplates");
				break;
			case "Tipuri necesare LUNARE":
				navigate("/monthlyRequestsTypes");
				break;
			case "Necesare LUNARE":
				navigate("/monthlyRequests");
				break;
			case "Note de comanda":
				navigate("/commandNotes");
				break;
			case "Registru intrari":
				navigate("/registruIntrari");
				break;
			case "E-Facturi ANAF":
				navigate("/efacturi");
				break;
		}
	}

	const getCurrentSection = () => {
		//used to render current content from all sources
		switch(location.pathname) {
			case "/users":
				return(
					<Users session={props.session}/>
				);
			case "/activityLog":
				return(
					<ActivityLog session={props.session}/>
				);
			case "/providers":
				return(
					<Providers session={props.session}/>
				);
			case "/products":
				return(
					<Products session={props.session}/>
				);
			case "/centers":
				return(
					<Centers session={props.session}/>
				);
			case "/centersRequestsYearly":
				return(
					<CentersRequestsYearly session={props.session}/>
				);
			case "/mus":
				return(
					<ProductsMUs session={props.session}/>
				);
			case "/CentersRequestTemplates":
				return(
					<CentersRequestTemplates session={props.session}/>
				);
			case "/productsTypes":
				return(
					<ProductsTypes session={props.session}/>
				);
			case "/frameAgreements":
				return(
					<FrameAgreements session={props.session}/>
				);
			case "/subAgreements":
				return(
					<SubAgreements session={props.session}/>
				);
			case "/productsSummaryYearly":
				return(
					<ProductsSummaryYearly session={props.session}/>
				);
			case "/aquisitions":
				return(
					<Aquisitions session={props.session}/>
				);
			case "/directAquisitions":
				return(
					<DirectAquisitions session={props.session}/>
				);
			case "/unitData":
				return(
					<UnitData session={props.session}/>
				);
			case "/monthlyRequestsTemplates":
				return(
					<MonthlyRequestsTemplates session={props.session}/>
				);
			case "/monthlyRequestsTypes":
				return(
					<MonthlyRequestsTypes session={props.session}/>
				);
			case "/monthlyRequests":
				return(
					<MonthlyRequests session={props.session}/>
				);
			case "/commandNotes":
				return(
					<CommandNotes session={props.session}/>
				);
			case "/registruIntrari":
				return(
					<RegistruIntrari session={props.session}/>
				);
			case "/efacturi":
				return(
					<EFacturi session={props.session}/>
				);
			default:
				return(
					<Dashboard session={props.session}/>
				);
		}
	}

	const translateSection = () =>{
		//used for main dialog title
		switch(location.pathname) {
			case "/users":
				return "Utilizatori";
			case "/activityLog":
				return "Registru activitati";
			case "/providers":
				return "Nomenclator furnizori";
			case "/products":
				return "Nomenclator produse";
			case "/centers":
				return "Nomenclator centre";
			case "/centersRequestsYearly":
				return "Necesare ANUALE centre";
			case "/mus":
				return "Nomenclator unitati de masura";
			case "/CentersRequestTemplates":
				return "Sabloane necesare ANUALE";
			case "/productsTypes":
				return "Nomenclator tipuri de produse";
			case "/frameAgreements":
				return "Contracte cadru";
			case "/subAgreements":
				return "Contracte subsecvente";
			case "/productsSummaryYearly":
				return "Centralizator necesare anuale";
			case "/aquisitions":
				return "Achizitii cu contract";
			case "/directAquisitions":
				return "Achizitii directe";
			case "/unitData":
				return "Date unitate";
			case "/monthlyRequestsTemplates":
				return "Sabloane necesare LUNARE";
			case "/monthlyRequestsTypes":
				return "Tipuri necesare LUNARE";
			case "/monthlyRequests":
				return "Necesare LUNARE centre";
			case "/commandNotes":
				return "Note de comanda";
			case "/registruIntrari":
				return "Registru intrari";
			case "/efacturi":
				return "E-Facturi ANAF";
			default:
				return "Pagina principala";
		}
	}

	const changeMenuCategory = (evt,category) => {
		(menuCategory===category.id?setMenuCategory(0):setMenuCategory(category.id));
	}

    const leftToolBarContents = (
        <React.Fragment>
			<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
				{!!(menuOpen) &&
					<Button label="Meniu" icon="pi pi-times" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"8px"}} onClick={(evt) => handleButton(evt,"menu")}/>
				}
				{!!(!menuOpen) &&
					<Button label="Meniu" icon="pi pi-bars" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"8px"}} onClick={(evt) => handleButton(evt,"menu")}/>
				}
				<Button label="Pagina principala" icon="pi pi-home" className="p-button-sm p-button-success p-button-raised" style={{"marginLeft":"24px"}} onClick={(evt) => handleButton(evt,"dashboard")}/>
			</Box>
			<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>
				<Button icon="pi pi-bars" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"menu")}/>
			</Box>
        </React.Fragment>
    );

    const rightToolBarContents = (
        <React.Fragment>
			<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
				<p style={{"marginRight":"12px","display":"inline","lineHeight":"2.1","color":"#FFFFFF"}}>{props.session.name}</p>
				<Button label="Setari" icon="pi pi-cog" style={{"marginRight":"9px"}} className="p-button-sm p-button-success p-button-raised" onClick={(evt) => handleButton(evt,"user_settings")}/>
				<Button label="Logout" icon="pi pi-power-off" className="p-button-sm p-button-danger p-button-raised" onClick={(evt) => props.logoutHandler(evt)}/>
			</Box>
			<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>
				<Button icon="pi pi-cog" style={{"marginRight":"9px"}} className="p-button-sm p-button-success p-button-raised" onClick={(evt) => handleButton(evt,"user_settings")}/>
				<Button icon="pi pi-power-off" className="p-button-sm p-button-success p-button-raised" onClick={(evt) => props.logoutHandler(evt)}/>
			</Box>
        </React.Fragment>
    );

	const userSettingsDialog = () => {
		return(
			<Dialog header={dialogValues.titleUserSettings} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openUserSettings:false})} className="responsive-dialog-med-small" contentStyle={{"paddingBottom":"15px"}}>
				<UserSettings session={props.session}/>
			</Dialog>
		);
	}

	if(dataOk) {
		return(
			<div style={{}}>
				<Sidebar visible={menuOpen} onHide={() => setMenuOpen(false)} style={{"width":"342px","marginTop":"33px","height":"843px","borderRadius":"3px"}}>
					<h3 style={{"width":"100","textAlign":"center","marginBottom":"30px"}}>Meniu principal</h3>
					{menuCategories && menuCategories.map((category,index) => 
						<div key={index} onClick={(evt) => changeMenuCategory(evt,category)}>
							{!!(menuCategory===category.id) &&
								<Button label={category.name} icon="pi pi-chevron-down" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
							}
							{!!(menuCategory!==category.id) &&
								<Button label={category.name} icon="pi pi-chevron-right" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
							}
							{menuSections && menuSections.map((section,index) => 
								!!((section.menu_categories_id===category.id)&&(category.id===menuCategory)) &&
									<div key={index} style={{"marginLeft":"30px"}} onClick={(evt) => handleSection(evt,section.name)}>
										<MenuIcons section={section.name}/>
									</div>
							)}
						</div>
					)}
				</Sidebar>
				<Toolbar left={leftToolBarContents} right={rightToolBarContents} className="main-toolbar" style={{}}/>
				<div style={{"minHeight":"87.9vh","padding":"15px","paddingLeft":"12px","paddingRight":"0px"}}>
					<div style={{"textAlign":"left","marginLeft":"12px","color":"#000000"}}>
						<h4>{translateSection()}</h4>
					</div>
					{getCurrentSection()}				
				</div>
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openUserSettings && userSettingsDialog()}
			</div>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);
	}
}
